// ============================================
// SINGLE SOURCE OF TRUTH FOR ALL COLORS



export const colors = {
    // Primary Colors - Main brand color
    PRIMARY: "rgb(37 99 235)", // Blue - Change this to change primary color everywhere!
    PRIMARY_LIGHT: "rgb(191 219 254)", // Light Blue
    PRIMARY_LIGHTER: "rgb(219 234 254)", // Lighter Blue
    PRIMARY_DARK: "rgb(29 78 216)", // Dark Blue

    // Secondary Colors
    SECONDARY: "rgb(99 102 241)", // Indigo
    SECONDARY_LIGHT: "rgb(199 210 254)", // Light Indigo
    SECONDARY_DARK: "rgb(79 70 229)", // Dark Indigo

    // Text Colors
    TEXT_PRIMARY: "rgb(17 24 39)", // Dark Gray
    TEXT_SECONDARY: "rgb(107 114 128)", // Gray
    TEXT_MUTED: "rgb(156 163 175)", // Light Gray

    // Background Colors
    BG_WHITE: "rgb(255 255 255)",
    BG_GRAY: "rgb(249 250 251)",
    BG_GRAY_LIGHT: "rgb(243 244 246)",

    // Border Colors
    BORDER_GRAY: "rgb(229 231 235)",
    BORDER_GRAY_LIGHT: "rgb(243 244 246)",

    // Success Colors
    SUCCESS: "rgb(34 197 94)",
    SUCCESS_LIGHT: "rgb(220 252 231)",
    SUCCESS_DARK: "rgb(22 163 74)",

    // Danger Colors
    DANGER: "rgb(239 68 68)",
    DANGER_LIGHT: "rgb(254 226 226)",
    DANGER_DARK: "rgb(220 38 38)",

    // Warning Colors
    WARNING: "rgb(251 146 60)",
    WARNING_LIGHT: "rgb(254 243 199)",
    WARNING_DARK: "rgb(234 88 12)",

    // Hover States
    HOVER_BG: "rgb(243 244 246)",
    HOVER_PRIMARY: "rgb(29 78 216)",
}

// ============================================
// HELPER FUNCTION - DO NOT EDIT
// Converts "rgb(R G B)" to "R G B" for Tailwind
// ============================================
const toTailwind = (rgbString) => {
    return rgbString.replace("rgb(", "").replace(")", "");
}

// ============================================
// AUTO-GENERATED TAILWIND COLORS - DO NOT EDIT
// This is automatically generated from colors above
// ============================================
export const tailwindColors = {
    primary: {
        lighter: toTailwind(colors.PRIMARY_LIGHTER),
        DEFAULT: toTailwind(colors.PRIMARY),
        light: toTailwind(colors.PRIMARY_LIGHT),
        dark: toTailwind(colors.PRIMARY_DARK),
        foreground: toTailwind(colors.BG_WHITE),
    },
    secondary: {
        lighter: toTailwind(colors.SECONDARY_LIGHT),
        DEFAULT: toTailwind(colors.SECONDARY),
        dark: toTailwind(colors.SECONDARY_DARK),
        foreground: toTailwind(colors.BG_WHITE),
    },
    muted: {
        DEFAULT: toTailwind(colors.BORDER_GRAY),
    },
    background: toTailwind(colors.BG_WHITE),
    foreground: toTailwind(colors.TEXT_SECONDARY),
    red: {
        lighter: toTailwind(colors.DANGER_LIGHT),
        DEFAULT: toTailwind(colors.DANGER),
        dark: toTailwind(colors.DANGER_DARK),
    },
    orange: {
        lighter: toTailwind(colors.WARNING_LIGHT),
        DEFAULT: toTailwind(colors.WARNING),
        dark: toTailwind(colors.WARNING_DARK),
    },
    green: {
        lighter: toTailwind(colors.SUCCESS_LIGHT),
        DEFAULT: toTailwind(colors.SUCCESS),
        dark: toTailwind(colors.SUCCESS_DARK),
    },
}